import{_ as r}from"./_arrayReduce.js";import{d as o}from"./deburr.js";import{w as a}from"./words.js";var e=r,s=o,t=a,m=RegExp("['’]","g");var n=function(r){return function(o){return e(t(s(o).replace(m,"")),r,"")}};export{n as _};
//# sourceMappingURL=_createCompounder.js.map
